export enum BusinessModel {
  BUILD_OWN = 'BUILD_OWN',
  BUILD_SELL_PART = 'BUILD_SELL_PART',
  BUILD_SELL_ALL = 'BUILD_SELL_ALL',
  DEVELOP_SELL = 'DEVELOP_SELL',
}
export const businessModelToLabel: {[value: string]: string} = {
  [BusinessModel.BUILD_OWN]: 'Build & Own',
  [BusinessModel.BUILD_SELL_PART]: 'Build & Sell (Part)',
  [BusinessModel.BUILD_SELL_ALL]: 'Build & Sell (All)',
  [BusinessModel.DEVELOP_SELL]: 'Develop & Sell',
};
export const isDivestment: Record<BusinessModel, boolean> = {
  [BusinessModel.BUILD_OWN]: false,
  [BusinessModel.BUILD_SELL_PART]: true,
  [BusinessModel.BUILD_SELL_ALL]: true,
  [BusinessModel.DEVELOP_SELL]: true,
};
